const pwaCleanupCompletedKey = 'lfc_pwa_cleanup_v1_completed';

const hasCompletedCleanup = (): boolean => {
  try {
    return window.localStorage.getItem(pwaCleanupCompletedKey) === 'true';
  } catch {
    return false;
  }
};

const markCleanupCompleted = (): void => {
  try {
    window.localStorage.setItem(pwaCleanupCompletedKey, 'true');
  } catch {
    // Cleanup itself is more important than persisting this best-effort guard.
  }
};

export const cleanupPwaArtifacts = async (): Promise<void> => {
  if (hasCompletedCleanup()) {
    return;
  }

  if ('serviceWorker' in navigator && navigator.serviceWorker?.getRegistrations) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map(registration => registration.unregister()));
  }

  if ('caches' in window && window.caches) {
    const keys = await window.caches.keys();
    await Promise.all(keys.map(key => window.caches.delete(key)));
  }

  markCleanupCompleted();
};
